import { render, staticRenderFns } from "./training-materials-wap.vue?vue&type=template&id=008b211c&scoped=true"
import script from "./training-materials-wap.vue?vue&type=script&lang=js"
export * from "./training-materials-wap.vue?vue&type=script&lang=js"
import style0 from "./training-materials-wap.vue?vue&type=style&index=0&id=008b211c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008b211c",
  null
  
)

export default component.exports